import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@dossierhq/design';
import debounce from 'lodash/debounce.js';
import { useMemo, useState } from 'react';
import { SearchEntityStateActions, } from '../../reducers/SearchEntityReducer/SearchEntityReducer.js';
export function SearchEntitySearchInput({ searchEntityState, dispatchSearchEntityState }) {
    const [text, setText] = useState(searchEntityState.text);
    const handleChange = useMemo(() => {
        const handler = (value) => {
            dispatchSearchEntityState(new SearchEntityStateActions.SetQuery({ text: value }, { partial: true, resetPagingIfModifying: true }));
        };
        return debounce(handler, 300);
    }, [dispatchSearchEntityState]);
    return (_jsx(Input, { iconLeft: "search", value: text, placeholder: "Search", onChange: (e) => {
            setText(e.target.value);
            handleChange(e.target.value);
        } }));
}
//# sourceMappingURL=SearchEntitySearchInput.js.map